(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  function retriggerOpenTransition(details) {
    var wrap = details.querySelector('.product-how-to-clean-care__content-wrap');
    if (!wrap) return;
    wrap.style.gridTemplateRows = '0fr';
    void wrap.offsetHeight;
    wrap.style.removeProperty('grid-template-rows');
  }

  function init(d) {
    d.addEventListener('toggle', function () {
      if (d.open) {
        retriggerOpenTransition(d);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.product-how-to-clean-care').forEach(init);
    });
  } else {
    document.querySelectorAll('.product-how-to-clean-care').forEach(init);
  }
})();
